import { z } from 'zod';
import { emailSchema, passwordSchema } from './auth.js';
/**
 * A tenant: one company with its own team, fairs and field catalogue.
 *
 * Only the platform role sees these routes. A team lead administers inside
 * their tenant and never learns that others exist.
 */
export const tenantSlugSchema = z
    .string()
    .min(2)
    .max(32)
    .regex(/^[a-z][a-z0-9-]*$/, 'Das Kürzel besteht aus Kleinbuchstaben, Ziffern und Bindestrichen und beginnt mit einem Buchstaben');
export const tenantViewSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    slug: z.string(),
    isActive: z.boolean(),
    /** How many accounts belong to it — the quickest sign of a tenant in use. */
    userCount: z.number().int(),
    eventCount: z.number().int(),
    itemCount: z.number().int(),
    createdAt: z.iso.datetime({ offset: true }),
});
/**
 * Creating a tenant also creates its first team lead.
 *
 * Deliberately one step: a tenant nobody can log into is not a tenant, and
 * leaving the two apart would allow exactly that state to exist.
 */
export const tenantCreateSchema = z.object({
    name: z.string().min(1).max(200),
    slug: tenantSlugSchema,
    leadName: z.string().min(1).max(200),
    leadEmail: emailSchema,
    /** Optional; the server generates one and returns it exactly once. */
    leadPassword: passwordSchema.optional(),
});
export const tenantCreatedSchema = z.object({
    tenant: tenantViewSchema,
    lead: z.object({
        id: z.uuid(),
        email: z.string(),
        name: z.string(),
        /**
         * Shown once and never stored in readable form. The platform admin passes
         * it on; there is no mail dispatch in this system, which is a decision, not
         * an oversight — see docs/DECISIONS.md.
         */
        password: z.string(),
    }),
});
export const tenantUpdateSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    /**
     * Standing a tenant down blocks every login belonging to it, immediately —
     * tokens already issued stop working on their next request. Nothing is
     * deleted: the articles of a customer who stops paying are still theirs.
     */
    isActive: z.boolean().optional(),
});
//# sourceMappingURL=tenant-api.js.map